import type { GlobalBootstrapCache, GlobalStore } from "./types"

export function createInitialGlobalStore(input: {
  bootstrap?: GlobalBootstrapCache
}): GlobalStore {
  const bootstrap = input.bootstrap
  return {
    ready: false,
    path: bootstrap?.path ?? {
      state: "",
      config: "",
      worktree: "",
      directory: "",
      home: "",
    },
    project: bootstrap?.project ?? [],
    machineWorkspace: bootstrap?.machineWorkspace,
    provider: bootstrap?.provider ?? { all: [], connected: [], default: {} },
    config: bootstrap?.config ?? {},
    session: [],
    session_removed: {},
    sessionTotal: {},
    session_status: {},
    session_waiting: {},
    pty_activity: {},
    session_diff: {},
    session_diff_summary: {},
    session_followup: {},
    permission: {},
    question: {},
    request_route: {},
    message: {},
    message_actor: {},
    part: {},
  }
}
